'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('../SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavTeam = (_temp = _class = function (_SvgIcon) {
  _inherits(NavTeam, _SvgIcon);

  function NavTeam() {
    _classCallCheck(this, NavTeam);

    return _possibleConstructorReturn(this, (NavTeam.__proto__ || Object.getPrototypeOf(NavTeam)).apply(this, arguments));
  }

  _createClass(NavTeam, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M33.168 15.275c-.602-.602-1.324-.933-1.96-1.226-.16-.074-.313-.145-.456-.216-1.425-.712-1.146-1.986-.233-3.81.46-.925.93-3.286-.015-4.817-.393-.635-1.203-1.393-2.833-1.393-1.63 0-2.442.758-2.834 1.393-.946 1.53-.476 3.892-.014 4.816.405.81.602 1.525.584 2.12-.022.748-.396 1.293-1.144 1.667-.133.066-.276.132-.424.202-.623.29-1.398.652-2.008 1.263-.18.18-.314.358-.425.53-.843-1.035-.6-2.617.73-5.277.78-1.56 1.572-5.55-.03-8.14C21.435 1.297 20.05 0 17.27 0c-2.778 0-4.164 1.298-4.837 2.387-1.602 2.59-.81 6.58-.03 8.14.66 1.318.977 2.47.95 3.426-.024.757-.268 1.368-.75 1.867-.112-.177-.25-.36-.435-.545-.602-.602-1.324-.934-1.96-1.226-.16-.074-.313-.145-.456-.216-.722-.36-1.034-.88-.982-1.63.05-.698.39-1.46.75-2.18.46-.924.932-3.285-.015-4.816-.392-.636-1.202-1.394-2.834-1.394-1.63 0-2.44.758-2.832 1.393-.946 1.53-.476 3.892-.014 4.816 1.403 2.806-.074 3.544-.56 3.787-.133.066-.276.132-.424.202-.622.29-1.397.652-2.008 1.263C.022 16.085 0 16.908 0 17l1 .008c0-.02.023-.51.54-1.026.486-.487 1.143-.794 1.723-1.064.156-.073.307-.144.448-.214 1.844-.92 2.2-2.742 1.01-5.128-.307-.612-.766-2.655-.032-3.844.382-.617 1.03-.918 1.983-.918.954 0 1.603.3 1.985.92.734 1.188.276 3.23-.03 3.842-.407.813-.792 1.686-.853 2.56-.08 1.154.45 2.05 1.533 2.593.152.075.315.15.484.227.56.258 1.195.55 1.67 1.025.158.157.26.306.337.445-.08.046-.157.094-.245.137-.22.11-.456.22-.702.336-1.04.486-2.336 1.09-3.37 2.122-1.386 1.39-1.426 2.82-1.426 2.978l2 .02c0-.03.043-.784.842-1.583.783-.783 1.854-1.284 2.8-1.725.263-.122.516-.24.75-.358 1.843-.92 2.847-2.422 2.905-4.34.04-1.29-.35-2.764-1.158-4.38-.495-.99-1.238-4.286-.058-6.196C14.732 2.47 15.758 2 17.27 2c1.512 0 2.54.47 3.136 1.438 1.18 1.91.438 5.206-.057 6.196-.894 1.785-3.263 6.527 1.203 8.76.254.127.525.252.807.38.96.443 1.953.9 2.717 1.663.8.8.84 1.552.842 1.563h2c0-.158-.04-1.59-1.43-2.978-1.017-1.017-2.28-1.597-3.295-2.064-.26-.12-.513-.235-.748-.353-.096-.048-.167-.106-.254-.157.08-.146.18-.3.346-.466.485-.487 1.143-.794 1.723-1.064.156-.073.307-.144.448-.214 1.077-.538 1.664-1.413 1.698-2.532.023-.76-.21-1.635-.69-2.596-.306-.612-.764-2.655-.03-3.843.382-.618 1.032-.92 1.984-.92s1.6.302 1.982.92c.735 1.188.277 3.23-.03 3.843-.576 1.152-1.924 3.85.68 5.153.153.075.316.15.485.227.56.258 1.196.55 1.67 1.025.517.516.54 1.005.54 1.018h1c0-.092-.023-.916-.832-1.725z' })
        );
      }

      return render;
    }()
  }]);

  return NavTeam;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 34 22.02051'
}, _temp);
exports['default'] = NavTeam;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Nav/NavTeam.js
// module id = 1872
// module chunks = 32